import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Label,
  Icon,
} from 'semantic-ui-react';

import Avatar from './../avatar';

const buttonStyle = {
  width: '100%',
};

const TeamMember = props => (
  <Card color={props.member.isUserSuperAdmin ? 'green' : 'grey'}>
    <Card.Content>
      <Avatar
        name={props.member.name}
        noTooltip
        size={40}
      />
      <Card.Header>
        { props.member.name }
      </Card.Header>
      <Card.Meta>
        { _.toLower(props.member.email) }
      </Card.Meta>
      <Card.Description>
        {
          props.member.isUserSuperAdmin
            ? <Label basic color="green"><Icon name="user circle outline" />Super Admin</Label>
            : <Label basic color="grey"><Icon name="user circle outline" />Team Member</Label>
        }
      </Card.Description>
    </Card.Content>
    <Card.Content extra>
      <div className="ui buttons" style={buttonStyle}>
        <Button
          color={props.buttonColor}
          icon={props.buttonIcon}
          basic
          content={props.buttonLabel}
          id={props.member.id}
          name={props.member.name}
          onClick={props.buttonClickHandler}
        />
      </div>
    </Card.Content>
  </Card>
);

TeamMember.propTypes = {
  member: PropTypes.object.isRequired,
  buttonClickHandler: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonIcon: PropTypes.string,
};

TeamMember.defaultProps = {
  buttonLabel: 'delete',
  buttonColor: 'red',
  buttonIcon: 'delete',
};

export default TeamMember;



/** WEBPACK FOOTER **
 ** ./src/components/team-member/index.js
 **/